import React, { useEffect, useState } from "react";
import PaginatedTable from "../paginatedTable";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import axios from "axios";

export default function UserActivity({ userId }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activityTypes, setActivityTypes] = useState([]);
  const [selectedActivityType, setSelectedActivityType] = useState("");

  // Intestazioni fisse con larghezza uniforme
  const header = [
    { field: "searchedOn", headerName: "Searched On", flex: 0.5 },
    { field: "keywords", headerName: "Type", flex: 1 },
    { field: "tags", headerName: "Value", flex: 1 },
  ];

  // Funzione per chiamare l'API /activities
  const fetchActivities = async () => {
    const params = { user_id: userId };
    if (selectedActivityType) {
      params.type = selectedActivityType;
    }

    const url = `${process.env.REACT_APP_API_URL}/activities`;
    const response = await axios.get(url, {
      params,
      headers: {
        // Authorization: `Bearer ${token}` // Decommenta se serve
      },
    });

    return response.data.data;
  };

  // Funzione che carica i dati e popola la tabella
  const loadData = async () => {
    try {
      setLoading(true);
      const activities = await fetchActivities();

      const finalRows = activities.map((act) => ({
        id: act.id,
        searchedOn: new Intl.DateTimeFormat("it-IT", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        }).format(new Date(act.created_at)),
        keywords: act.type?.name || "N/A",
        tags: act.value || "N/A",
      }));

      setItems(finalRows);
    } catch (error) {
      console.error("Error loading data:", error);
    } finally {
      setLoading(false);
    }
  };

  // Carica dati quando cambia userId o filtro selezionato
  useEffect(() => {
    if (userId) {
      loadData();
    }
  }, [userId, selectedActivityType]);

  // Carica le opzioni dei tipi attività
  useEffect(() => {
    const fetchActivityTypes = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/activities-types`);
        setActivityTypes(response.data.data);
      } catch (err) {
        console.error("Errore nel caricamento dei tipi di attività:", err);
      }
    };

    fetchActivityTypes();
  }, []);

  if (loading) {
    return <div>Loading user activity...</div>;
  }

  return (
    <React.Fragment>
      <h1 className="text-4xl font-medium mb-2">Search Activity</h1>
      <p>Keywords and Tags searched for</p>

      <FormControl sx={{ minWidth: 200, marginTop: 2, marginBottom: 3 }}>
        <InputLabel sx={{ fontFamily: 'Urbanist, sans-serif' }}>Filter by Type</InputLabel>
        <Select
          value={selectedActivityType}
          onChange={(e) => setSelectedActivityType(e.target.value)}
          sx={{
            border: selectedActivityType
              ? '1px solid rgb(var(--global-color-primary))'
              : '1px solid white',
            backgroundColor: '#191919',
            color: 'white',
            '.MuiOutlinedInput-notchedOutline': { border: 0 },
          }}
          displayEmpty
        >
          <MenuItem value="">All Types</MenuItem>
          {activityTypes.map((type) => (
            <MenuItem key={type.id} value={type.id}>
              {type.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <PaginatedTable header={header} items={items} perPage={10} />
    </React.Fragment>
  );
}
